<template>
  <el-popover
    placement="right"
    width="400"
    trigger="hover">
      <iframe-loader :url="getPreviewUrl"></iframe-loader>
      <a slot="reference" class="cursor-pointer" v-text="shortBody"></a>
  </el-popover>
</template>

<script>
import IframeLoader from '../../iframe-loader';

export default {
  components: {
    IframeLoader,
  },

  props: {
    row: Object,
  },

  data() {
    return {
      maxLength: 25,
    };
  },

  computed: {
    /**
     * @return {String}
     */
    shortBody() {
      return this.body.length < this.maxLength
        ? this.body
        : `${this.body.substring(0, this.maxLength)} ...`;
    },

    /**
     * @return {String}
     */
    body() {
      return _.get(this.row, 'model.data.content.text');
    },

    /**
     * @return {String}
     */
    getPreviewUrl() {
      return _.get(this.row, 'previewUrl');
    },
  },
}
</script>

<style scoped>

</style>
